if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer") && this.submitButton)
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // Validate pincode input before adding product to cart when using the main Add to Cart button
        let pdpATCButton = evt.target.querySelector(".add-to-cart-btn");
        let isPincodeEntered;
        if (pdpATCButton) {
          let customPincode = document.querySelector("pincode-element");
          if (customPincode) {
            isPincodeEntered = checkForCustomPincode();
          } else {
            isPincodeEntered = checkForPincode();
          }
          if (!isPincodeEntered) {
            return;
          }
        }

        if (
          this.submitButton &&
          this.submitButton.getAttribute("aria-disabled") === "true"
        )
          return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );
        if (this.querySelector(".add-cart--icon")) {
          this.querySelector(".add-cart--icon").classList.add("hidden");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const quantityElement = document.querySelector(
          `.quantity__input-pdp[data-variant-id="${formData.get("id")}"]`
        );

        if (quantityElement) {
          const quantity = Number.parseInt(quantityElement.value, 10);
          if (quantity >= 1) {
            formData.append("quantity", quantity);
          }
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status == 422) {
              handlePartialAdditionCase(response.description);
              this.handleErrorMessage(response.description);
              return;
            }
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");

              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              if (soldOutMessage) {
                soldOutMessage.classList.remove("hidden");
              }
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              // Add loading state to cart drawer
              const cartDrawer = document.querySelector("cart-drawer");
              if (cartDrawer) {
                cartDrawer.classList.add("is-updating");
              }

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    if (
                      document
                        .querySelector(".selector__wrapper modal-viewer")
                        .classList.contains("active")
                    ) {
                      document
                        .querySelector(".selector__wrapper modal-viewer")
                        .classList.remove("active");
                    }
                    this.cart.renderContents(response);

                    // Update bundle items after cart update
                    const selectedProducts =
                      document.querySelector("selected-products");
                    if (selectedProducts) {
                      selectedProducts.updateCartDrawerBundleItems();
                    }

                    // Remove loading state
                    const cartDrawer = document.querySelector("cart-drawer");
                    if (cartDrawer) {
                      cartDrawer.classList.remove("is-updating");
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (document.querySelector(".selector__wrapper modal-viewer")) {
                if (
                  document
                    .querySelector(".selector__wrapper modal-viewer")
                    .classList.contains("active")
                ) {
                  document
                    .querySelector(".selector__wrapper modal-viewer")
                    .classList.remove("active");
                }
              }
              this.cart.renderContents(response);

              // Update bundle items after cart update
              const selectedProducts =
                document.querySelector("selected-products");
              if (selectedProducts) {
                selectedProducts.updateCartDrawerBundleItems();
              }

              // Remove loading state
              const cartDrawer = document.querySelector("cart-drawer");
              if (cartDrawer) {
                cartDrawer.classList.remove("is-updating");
              }
            }
          })
          .catch((e) => {
            console.error("error", e);
          })
          .finally(() => {
            this.submitButton?.classList.remove("loading");
            if (this.cart && this.cart?.classList.contains("is-empty"))
              this.cart?.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner")?.classList.add(
              "hidden"
            );
            this.querySelector(".add-cart--icon")?.classList.remove("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          document.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }

        setTimeout(() => {
          this.errorMessageWrapper?.setAttribute("hidden", "true");
        }, 3000);
      }
    }
  );
}

async function handlePartialAdditionCase(description) {
  if (
    description != "The maximum quantity of this item is already in your cart."
  ) {
    try {
      await fetch("/cart.js");
      const cartDrawer =
        document.querySelector("cart-drawer") ||
        document.querySelector("cart-notification");
      const sectionsToRender = cartDrawer
        .getSectionsToRender()
        .map((section) => section.id);
      const response = await fetch(
        `/cart?sections=${sectionsToRender.join(",")}`
      );
      const sectionHTML = await response.json();
      cartDrawer.renderContents({ sections: sectionHTML });
    } catch (err) {
      console.error(err);
    }
  }
}

function checkForPincode() {
  let pincodeElement =
    document.querySelector("input[name=drop_pincode]") ||
    document.querySelector("input[name=pincodeInput]");
  if (pincodeElement && !window.isPincodeFetched) {
    const pincodeElement = document.querySelector(".delivery-check");
    const lastProductImage = document.querySelector(
      "media-gallery .product__media-item:last-of-type"
    );

    if (!pincodeElement) return;

    // Function to check if the element is already fully visible in the viewport
    const isInView = (el) => {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight)
      );
    };

    // Only scroll if the pincode element is NOT already visible
    if (!isInView(pincodeElement)) {
      if (window.matchMedia("(max-width: 768px)").matches) {
        pincodeElement.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        (lastProductImage ?? pincodeElement).scrollIntoView({
          behavior: "smooth",
        });
      }
    }

    document.querySelector(".pincode-failure").classList.remove("hidden");
    return false;
  } else {
    return true;
  }
}

function checkForCustomPincode() {
  let pincodeElement = document.querySelector("input[name=pincodeInput]");
  if (pincodeElement && !window.isPincodeFetched) {
    const lastProductImage = document.querySelector(
      "media-gallery .product__media-item:last-of-type"
    );

    if (!pincodeElement) return;

    // Function to check if the element is already fully visible in the viewport
    const isInView = (el) => {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight)
      );
    };

    // Only scroll if the pincode element is NOT already visible
    if (!isInView(pincodeElement)) {
      if (window.matchMedia("(max-width: 768px)").matches) {
        pincodeElement.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        (lastProductImage ?? pincodeElement).scrollIntoView({
          behavior: "smooth",
        });
      }
    }

    document.querySelector(".pincode-failure").classList.remove("hidden");
    if (document.querySelector(".add-to-cart-btn")) {
      document
        .querySelector(".add-to-cart-btn")
        .setAttribute("disabled", "true");
    }
    if (document.querySelector(".personalise-button")) {
      document
        .querySelector(".personalise-button")
        .setAttribute("disabled", "true");
    }
    return false;
  } else {
    return true;
  }
}
